import { render, staticRenderFns } from "./FarmItem.vue?vue&type=template&id=66719717&scoped=true&"
import script from "./FarmItem.vue?vue&type=script&lang=ts&"
export * from "./FarmItem.vue?vue&type=script&lang=ts&"
import style0 from "./farmItem.scss?vue&type=style&index=0&id=66719717&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66719717",
  null
  
)

export default component.exports